import { render, staticRenderFns } from "./Subtitle.vue?vue&type=template&id=ab37a1e0&"
import script from "./Subtitle.vue?vue&type=script&lang=js&"
export * from "./Subtitle.vue?vue&type=script&lang=js&"
import style0 from "./Subtitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qhotian/Project/haodf/hb-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab37a1e0')) {
      api.createRecord('ab37a1e0', component.options)
    } else {
      api.reload('ab37a1e0', component.options)
    }
    module.hot.accept("./Subtitle.vue?vue&type=template&id=ab37a1e0&", function () {
      api.rerender('ab37a1e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/detailComp/subtitle/Subtitle.vue"
export default component.exports